// removed by extract-text-webpack-plugin
module.exports = {"container":"index__container--19J70","image":"index__image--1iw5-","imageOverlay":"index__imageOverlay--mf-oV","imageUploadButton":"index__imageUploadButton--3xL3n"};


//////////////////
// WEBPACK FOOTER
// ./src/client/shared-components/ImageUpload/styles/index.scss
// module id = Qi+x
// module chunks = 23